module.exports = __webpack_public_path__ + "static/media/marvelous_02.e198e950.jpg";